import { BaseMockService } from '@services/base-mock.service';
import { Observable, of } from 'rxjs';
import { VehicleResponse } from '../../app/features/connect/domain/vehicle.model';
import { VehiclesRepository } from '../../app/features/connect/infrastructure/vehicles.repository';
import { VEHICLES_RESPONSE } from '../dataMocks/vehicles-response-post';

export class VehiclesApiMockService extends BaseMockService implements VehiclesRepository {
    constructor() {
        super('vehicles');
    }

    createVehicle(): Observable<VehicleResponse> {
        return this.handle('createVehicle', of({ ...VEHICLES_RESPONSE }));
    }
    getVehicles(): Observable<VehicleResponse[]> {
        return this.handle('getVehicles', of([]));
    }
    getVehicle(): Observable<VehicleResponse> {
        return this.handle('getVehicle', of({} as VehicleResponse));
    }
    deleteVehicle(): Observable<void> {
        return this.handle('deleteVehicle', of(undefined));
    }
}
